module.exports = __webpack_public_path__ + "img/card2.4cd7039b.png";